import { NavLink, useLocation } from 'react-router-dom';
import './LeftNavigationLinks.css';
import { Fragment, useEffect, useState } from 'react';
import { useStateValue } from '../../../StateProvider';
import ReportCreditsIndicator from '../../account/reportCreditsIndicator/ReportCreditsIndicator';

const LeftNavigationLinks = ({ onLinkClick = null }) => {
	const className = 'app-left-nav-link';
	const activeClassName = 'app-left-nav-link active';
	const [ { user }, dispatch ] = useStateValue();
	const [ defaultActiveLink, setDefaultActiveLink ] = useState();
	const location = useLocation();

	useEffect(
		() => {
			setDefaultActiveLink(location.pathname === '/');
		},
		[ location ]
	);

	const handleLinkClick = (type) => {
		if (onLinkClick) {
			onLinkClick(type);
		}
		setDefaultActiveLink(false);
	};

	return (
		<div className="app-left-nav-links">
			{user.isSalesUser ? (
				<Fragment>
					<NavLink
						to="/companies"
						className={({ isActive }) => (isActive || defaultActiveLink ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-briefcase" />
						</div>
						<span className="app-left-nav-link-text">Companies</span>
					</NavLink>
					<NavLink to="/reports" className={({ isActive }) => (isActive ? activeClassName : className)}>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-chart-bar" />
						</div>
						<span className="app-left-nav-link-text">Reports</span>
					</NavLink>
					<NavLink
						to="/campaigns"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-bullhorn" />
						</div>
						<span className="app-left-nav-link-text">Campaigns</span>
					</NavLink>
					<NavLink
						to="/offers"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-hand-holding-dollar" />
						</div>
						<span className="app-left-nav-link-text">Offers</span>
					</NavLink>
					<NavLink
						to="/account"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-user-gear" />
						</div>
						<span className="app-left-nav-link-text">Account</span>
					</NavLink>

					<ReportCreditsIndicator />
				</Fragment>
			) : (
				<Fragment>
					{/* <NavLink
						to="/companies"
						className={({ isActive }) => (isActive || defaultActiveLink ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-briefcase" />
						</div>
						<span className="app-left-nav-link-text">Companies</span>
					</NavLink>
					<NavLink
						to="/reports"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-chart-bar" />
						</div>
						<span className="app-left-nav-link-text">Reports</span>
					</NavLink> */}
					<NavLink
						to="/campaigns"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-bullhorn" />
						</div>
						<span className="app-left-nav-link-text">Campaigns</span>
					</NavLink>
					<NavLink
						to="/support"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={() => handleLinkClick('support')}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-circle-question" />
						</div>
						<span className="app-left-nav-link-text">Support</span>
					</NavLink>
					<NavLink
						to="/learning"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-brands fa-youtube" />
						</div>
						<span className="app-left-nav-link-text">Learning</span>
					</NavLink>
					<NavLink
						to="/payments"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-money-check-dollar" />
						</div>
						<span className="app-left-nav-link-text">Payments</span>
					</NavLink>
					<NavLink
						to="/account"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-user-gear" />
						</div>
						<span className="app-left-nav-link-text">Account</span>
					</NavLink>
					{/* <NavLink
						to="/cart"
						className={({ isActive }) => (isActive ? activeClassName : className)}
						onClick={handleLinkClick}
					>
						<div className="app-left-nav-link-icon">
							<i className="fa-solid fa-cart-shopping" />
						</div>
						<span className="app-left-nav-link-text">Cart</span>
					</NavLink> */}

					<ReportCreditsIndicator />
				</Fragment>
			)}
		</div>
	);
};

export default LeftNavigationLinks;
